module.exports = __webpack_public_path__ + "img/safra.d01fc8ac.svg";